export default __webpack_public_path__ + "static/media/menuLogo1.e76a3dd2.png";